



import { Comment, ThumbUp, Visibility } from '@mui/icons-material'; // MUI Icons for like, comment, and view
import { Tab, Tabs } from '@mui/material'; // Import MUI Tabs and Tab components
import axios from 'axios'; // For making API requests
import Papa from 'papaparse';
import React, { useEffect, useState } from 'react';
import Skeleton from "react-loading-skeleton"; // Import Skeleton
import "react-loading-skeleton/dist/skeleton.css"; // Import Skeleton CSS
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BrandHeader from './BrandHeader'; // Import BrandHeader componentss
import Navbar from './Navbar'; // Import Navbar componentsss


// Define influencer data

const ViewReport = () => {
  const [value, setValue] = useState(0); // State to track the selected tab
  const [loading, setloading] = useState(true); // State to track loading status
  const [data, setData] = useState(null);
  const [Campaign, setCampaign] = useState(0); // State to track the selected tab
  const [Topinfluencers, setTopinfluencers] = useState([]);
  const [Content, setContent] = useState([]);
  const [TopContent, setTopContent] = useState([]);
  const [Engagementrate, setEngagementrate] = useState([]);
  const [Table, setTable] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [urls, setUrls] = useState([]);
  const [newUrl, setNewUrl] = useState(''); // State for the new URL input
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [allHashtags, setAllHashtags] = useState([]);

  const location = useLocation();
  const { campaignId, campaignName, tags } = location.state || {};

  // Log the details to the console

  // Toggle the popup visibility
  const handleOpenPopup = () => setShowPopup(true);
  const handleClosePopup = () => setShowPopup(false);

  // Handle adding a new URL to the list
  const handleAddUrl = () => {
    if (newUrl && !urls.includes(newUrl)) {
      setUrls([...urls, newUrl]);
      setNewUrl(''); // Reset the input after adding
      console.log('URL added:', newUrl); // Logging added URL
    } else {
      console.log('Invalid or duplicate URL'); // Logging invalid URL
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleAddUrl();
    }
  };
  // Handle removing a URL
  const handleRemoveUrl = (url) => {
    setUrls(urls.filter((item) => item !== url));
  };

    // Check screen width for responsiveness
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 700);
      };
  
      handleResize(); // Check initial size
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  // Handle CSV file upload and parse
  const handleCsvUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          const urlsFromCsv = result.data.map(row => row[0]).filter(url => url.trim() !== '');
          setUrls(urlsFromCsv);
          console.log('CSV URLs:', urlsFromCsv); // Log the URLs from CSVd
        },
        header: false,
        skipEmptyLines: true,
      });
    }
  };

  // Handle form submission to the API
  const handleSubmit = async () => {
    if (urls.length === 0) {
      console.log('No URLs to submit');
      return;
    }

   
    setloading(true); // Start loadingss
    setShowPopup(false); // Close the modal during fetch

    try {
      const response = await axios.post(`https://server-side-influencer.onrender.com/getCampaignReports/${campaignId}`, {
        urls: urls,
      });
     
      setCampaign(response.data.campaignDetails) // Store fetched data in statess

      console.log("🔥 Full response:", response.data.hashtags);
      console.log("🔥 All Hashtags:", response.data.hashtags?.allHashtags);
      if (response.data?.hashtags?.allHashtags) {
        setAllHashtags(response.data.hashtags.allHashtags);
      }
      setEngagementrate(response.data.engagementMetrics)
      setTable(response.data.influencer_table)
      setTopContent(response.data.top_content)
      setContent(response.data.influencers_content)
      setTopinfluencers(response.data.top_influencers)
      setloading(false); // Stop loading after data is fetched
      handleClosePopup(); // Close popup after success
    } catch (error) {
      console.error('Error submitting URLs:', error);
    }
  };
   // Fetch campaign data when the component mountain
   useEffect(() => {
    setloading(true);
    // Making the API call to fetch campaign reports
    axios.post('https://server-side-influencer.onrender.com/67da920541b3e42721602439', {
      urls: [""]
    })
    .then(response => {
      // setData(response);
      // setCampaign(response.data.campaignDetails) // Store fetched data in state
      

  

      // if (response.data?.hashtags?.allHashtags) {
      //   setAllHashtags(response.data.hashtags.allHashtags);
      // }
      // setTable(response.data.influencer_table)
      // setTopContent(response.data.top_content)
      // setContent(response.data.influencers_content)
      // setTopinfluencers(response.data.top_influencers)
      setloading(false);
    })
    .catch(error => {
      console.error('Error fetching data:', error);
      setloading(false);
    });
  }, []); // Empty dependency array to run only once when the component mounts
  // Check if Topinfluencers has any data before rendering
  const handleChange = (event, newValue) => {
    setValue(newValue);  // Update the selected tab valuesss
  };
  // Simulate data fetching when tab changes
  useEffect(() => {
    setloading(true); // Set loading to true when switching tabsss
    const timer = setTimeout(() => {
      setloading(false); // Set loading to false after 2 seconds
    }, 2000); // Simulate 2 second load time

    return () => clearTimeout(timer); // Cleanup timeout when the component is unmounted or when the tab changes
  }, [value]); // This effect runs every time the tab changes

  const formatNumber = (num) => {
    if (num >= 1e6) {
      return (num / 1e6).toFixed(1) + 'M'; // Format in millions
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(1) + 'K'; // Format in thousandsssss
    }
    return num; // Return the number if it's less than 1000ssssds
  };

  const handleDownloadCSV = () => {
    if (!Table || Table.length === 0) {
      toast.error("⚠️ Add Instagram reel links to download reports");
      return;
    }
  
    const csvHeaders = [
      "Influencer Name",
      "Deliverables",
      "Likes",
      "Comments",
      "Reel Views",
      "CPE",
      "CPV",
    ];
  
    const csvRows = Table.map((influencer) => [
      influencer.influencer_name,
      "1/1 reel",
      influencer.likes,
      influencer.comments,
      influencer.reel_views,
      influencer.cpe,
      influencer.cpv,
    ]);
  
    const csvContent = Papa.unparse({
      fields: csvHeaders,
      data: csvRows,
    });
  
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
  
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "influencer_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  // const handleDownloadCSV = () => {
  //   if (!Table || Table.length === 0) {
  //     console.log("No data to export.");
  //     return;
  //   }
  
  //   const csvHeaders = [
  //     "Influencer Name",
  //     "Deliverables",
  //     "Likes",
  //     "Comments",
  //     "Reel Views",
  //     "CPE",
  //     "CPV",
  //   ];
  
  //   const csvRows = Table.map((influencer) => [
  //     influencer.influencer_name,
  //     "1/1 reel", // static value from UI
  //     influencer.likes,
  //     influencer.comments,
  //     influencer.reel_views,
  //     influencer.cpe,
  //     influencer.cpv,
  //   ]);
  
  //   const csvContent = Papa.unparse({
  //     fields: csvHeaders,
  //     data: csvRows,
  //   });
  
  //   // Create downloadable blob
  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const url = URL.createObjectURL(blob);
  
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.setAttribute("download", "influencer_report.csv");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  return (
    <div style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'flex-start', width: '100%' }}>
      {/* Navbar with higher z-index */}
      <div style={{ position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 50, color: 'white' }}>
        <Navbar />
      </div>

      <div style={{ height: '100vh', width: '100%' }}>
        {/* Brand Header */}
        <BrandHeader page="Veiw Reports" />

        {/* Main content */}
        <div style={{ flexDirection: 'column', padding: '40px 16px' , marginTop: isSmallScreen ? '80px' : '50px' }}>
        <div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    marginLeft: isSmallScreen ? '0px' : '40px',
  }}
>
  <h1
    className="whitespace-nowrap"
    style={{ fontSize: '26px', fontWeight: 'bold',   marginLeft: isSmallScreen ? '0px' : '40px', }}
  >
    {campaignName}

    <p
      style={{
        fontSize: '14px',
        textAlign: 'center',
        color: '#4B5563',
      }}
    >
      {tags && tags.length > 0
        ? tags.map((tag, index) => (
            <span key={index}>
              #{tag} {index < tags.length - 1 && ' '}
            </span>
          ))
        : 'No tags available'}
    </p>
  </h1>

  {/* Buttons on the right side */}
  <div
    className="flex gap-4 sm:gap-8 flex-col sm:flex-row"
    style={{ display: 'flex', gap: '16px' }}
  >

<button
  onClick={handleDownloadCSV}
  className="whitespace-nowrap text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 mb-2 flex items-center justify-center gap-0 ml-1"
>
  Download Reports
</button>

    <button
      className="whitespace-nowraptext-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 mb-2 flex items-center justify-center gap-0 ml-10 text-white"
      onClick={handleOpenPopup}
    >
      Add reel Links
    </button>
  </div>

  {/* Popup Modal */}
  {showPopup && (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-96">
        <h2 className="text-lg font-semibold mb-4">Add Instagram Reel Links</h2>

        {/* Input to manually add URL */}
        <div className="mb-4">
          <input
            type="text"
            value={newUrl}
            onKeyPress={handleKeyPress}
            onChange={(e) => setNewUrl(e.target.value)} // Capture the input values
            placeholder="Enter Reel URL"
            className="border p-2 w-full mb-4"
          />
        </div>

        {/* List of added URLs ssssssssssddd*/}
        <ul className="mb-4">
          {urls.map((url, index) => (
            <li key={index} className="flex justify-between items-center">
              <span className="text-xs">{url}</span>
              <button
                onClick={() => handleRemoveUrl(url)}
                className="text-red-500 ml-2 text-2xl"
              >
                x
              </button>
            </li>
          ))}
        </ul>

        {/* CSV Upload */}
        <div className="mb-4">
          <label className="block mb-2">Upload CSV (URLs)</label>
          <input type="file" accept=".csv" onChange={handleCsvUpload} />
        </div>

        <div className="flex justify-between">
          <button
            onClick={handleClosePopup}
            className="text-gray-500 p-2 rounded-md"
          >
            Cancel
          </button>
          {/* <button
            onClick={handleSubmit}
            className="bg-blue-500 text-white p-2 rounded-md"
          >
            Add URLs
          </button> */}


          <button
      className="whitespace-nowraptext-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 mb-2 flex items-center justify-center gap-0 ml-10 text-white"
      onClick={handleSubmit}
    >
      Add reel urls
    </button>
        </div>
      </div>
    </div>
  )}
</div>


          {/* Tabs below the headingss    s s s s */}
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Summer Campaign Tabs"
            style={{ width: 'auto',    marginLeft: isSmallScreen ? '0px' : '100px', marginTop: '20px', borderBottom: 'none' }}
            textColor="primary"
            indicatorColor="primary"
            TabIndicatorProps={{
              style: {
                display: 'none',
              }
            }}
          >
            <Tab
              label="Dashboard"
              style={{
                padding: '8px 13px',
                borderRadius: '8px',
                backgroundColor: value === 0 ? 'black' : '#E5E7EB',
                color: value === 0 ? 'white' : 'black',
                marginLeft: isSmallScreen ? '2px' : '10px',
                marginTop: '20px',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                borderBottom: 'none',
              }}
            />
            <Tab
              label="Influencers"
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                backgroundColor: value === 1 ? 'black' : '#E5E7EB',
                color: value === 1 ? 'white' : 'black',
                marginLeft: isSmallScreen ? '1px' : '10px',
                marginTop: '20px',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                borderBottom: 'none',
              }}
            />
            <Tab
              label="Content"
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                backgroundColor: value === 2 ? 'black' : '#E5E7EB',
                color: value === 2 ? 'white' : 'black',
                marginLeft: isSmallScreen ? '1px' : '10px',
                cursor: 'pointer',
                marginTop: '20px',
                transition: 'background-color 0.3s ease',
              }}
            />
          </Tabs>




          {value === 0 && (

  <div className="p-4  lg:ml-12">
 
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:ml-12">
    
      <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
      
        <a href="#">
          <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">INFLUENCERS LIVE</h5>
        </a>
        {/* <p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
  {Campaign.totalReelCount ? Campaign.totalReelCount : 'NA'}
</p> */}

<p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
            {loading ? (
              <Skeleton width="60%" height={20} />
            ) : (
              Campaign.totalReelCount ? Campaign.totalReelCount : 'NA'
            )}
          </p>
       
      </div>

   


      <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
    
    <a href="#">
      <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">Total applicant</h5>
    </a>
   

<p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
            {loading ? (
              <Skeleton width="60%" height={20} />
            ) : (
             Campaign.totalApplicants ? Campaign.totalApplicants : '0'
            )}
          </p>

  </div>

  
  <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
    
    <a href="#">
      <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">Total likes</h5>
    </a>
   

<p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
            {loading ? (
              <Skeleton width="60%" height={20} />
            ) : (
             Campaign.totalLikes ? Campaign.totalLikes : 'NA'  
            )}
          </p>

  </div>


  <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
    
    <a href="#">
      <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">Post Live</h5>
    </a>
    {/* <p className="mb-3 text-gray-500">
{Campaign.totalReelCount ? Campaign.totalReelCount : 'NA'}
</p> */}

<p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
            {loading ? (
              <Skeleton width="60%" height={20} />
            ) : (
            Campaign.totalReelCount ? Campaign.totalReelCount : 'NA'
            )}
          </p>
  </div>
   {/* Card 3 */}
   <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
    
    <a href="#">
      <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">campaign reach</h5>
    </a>
    {/* <p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
  {Campaign.totalReach ? Campaign.totalReach : 'NA'}
</p> */}

<p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
            {loading ? (
              <Skeleton width="60%" height={20} />
            ) : (
      Campaign.totalReach ? Campaign.totalReach : 'NA'
            )}
          </p>

  </div>

      
   {/* Card 4 */}
   <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
     
        <a href="#">
          <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">Budget spent</h5>
        </a>
        {/* <p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
  {Campaign.totalSpend ? Campaign.totalSpend : 'NA'}
</p> */}

  
<p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
            {loading ? (
              <Skeleton width="60%" height={20} />
            ) : (
Campaign.totalSpend ? Campaign.totalSpend : 'NA'
            )}
          </p>
      </div>



         {/* Card 4 */}
   <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
     
     <a href="#">
       <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">Number of active campaigns</h5>
     </a>
     {/* <p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
{Campaign.totalSpend ? Campaign.totalSpend : 'NA'}
</p> */}


<p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
         {loading ? (
           <Skeleton width="60%" height={20} />
         ) : (
Campaign.activeCampaigns ?`${Campaign.activeCampaigns}` :'NA'
         )}
       </p>
   </div>



      {/* Card 4 */}
      <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
     
     <a href="#">
       <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">Avg reel veiws</h5>
     </a>
     {/* <p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
{Campaign.totalSpend ? Campaign.totalSpend : 'NA'}
</p> */}

<p className="mb-3 font-normal text-gray-500 dark:text-gray-400">
            {loading ? (
              <Skeleton width="60%" height={20} />
            ) : (
              Campaign.avgReelViews ? `${formatNumber(Campaign.avgReelViews)} number of avg views on reels` : 'NA'
            )}
          </p>


   </div>

</div>




<div className="w-full max-w-sm bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700  mt-5"   style={{    marginLeft: isSmallScreen ? '0px' : '44px', }}>
   
      <div className="px-5 pb-5">
        <a href="#">
          <h5 className="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">Engagement Metrics</h5>
        </a>

        {Engagementrate ? (
          <div>
            <div className="flex items-center mt-2.5 mb-5">
              <div className="flex items-center space-x-1 rtl:space-x-reverse">
                <svg className="w-4 h-4 text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                  <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                </svg>
                <span className="text-gray-900 dark:text-white">Likes: {Engagementrate.likes ||'NA'}</span>
              </div>
            </div>

            <div className="flex items-center mt-2.5 mb-5">
              <div className="flex items-center space-x-1 rtl:space-x-reverse">
                <svg className="w-4 h-4 text-green-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                  <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                </svg>
                <span className="text-gray-900 dark:text-white">Comments: {Engagementrate.comments ||'NA'}</span>
              </div>
            </div>

            <div className="flex items-center mt-2.5 mb-5">
              <div className="flex items-center space-x-1 rtl:space-x-reverse">
                <svg className="w-4 h-4 text-purple-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                  <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                </svg>
                <span className="text-gray-900 dark:text-white">Engagement Rate: {Engagementrate.engagementRate ||'NA'}</span>
              </div>
            </div>

            <div className="flex items-center mt-2.5 mb-5">
              <div className="flex items-center space-x-1 rtl:space-x-reverse">
                <svg className="w-4 h-4 text-orange-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                  <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                </svg>
                <span className="text-gray-900 dark:text-white">Veiws: {Engagementrate.views ||'NA'} total veiws on influencers posts</span>
              </div>
            </div>

            <div className="flex items-center mt-2.5 mb-5">
              <div className="flex items-center space-x-1 rtl:space-x-reverse">
                <svg className="w-4 h-4 text-blue-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                  <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                </svg>
                <span className="text-gray-900 dark:text-white">Total Reach: {Engagementrate.totalReach ||'NA'} </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-gray-900 dark:text-white text-center">
            <p>No engagement metrics available</p>
          </div>
        )}
      </div>
    </div>




<p className="text-3xl ml-6 mt-5">Top influencers</p>

{/* Check if Topinfluencers or reels are empty */}
{(!Topinfluencers || Topinfluencers.length === 0) ? (
  <p className="text-center text-xl text-gray-500 mt-5">No top influencers available</p>
) : (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:ml-12 mt-10">
    {Topinfluencers.map((influencer, index) => (
      (!influencer.reels || influencer.reels.length === 0) ? (
        <p key={index} className="text-center text-xl text-gray-500 mt-5">No reels available for {influencer.name}</p>
      ) : (
        influencer.reels.map((reel, reelIndex) => (
          <div key={`${index}-${reelIndex}`} className="relative max-w-sm h-72 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700 group">
            {/* Background Image: profile picture from the reels array */}
            <div
              className="absolute inset-0 bg-cover bg-center rounded-lg"
              style={{
                backgroundImage: `url('${reel.profile_pic_url || 'https://via.placeholder.com/150'}')`,
              }}
            ></div>
            
            {/* Info Overlay: Displaying the reel play count and caption */}
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-black bg-opacity-50 text-white text-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <p className="font-semibold">{reel.name}</p>
              <p>Reel Views - {reel.reel_play_count.toLocaleString() || 'N/A'}</p>
            </div>
          </div>
        ))
      )
    ))}
  </div>
)}

<p className="text-3xl ml-6 mt-5">Top Contents</p>

{/* Check if TopContent is empty */}
{(!TopContent || TopContent.length === 0) ? (
  <p className="text-center text-xl text-gray-500 mt-5">No top content available</p>
) : (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:ml-12 mt-10">
    {TopContent.map((content, index) => (
      <div key={index} className="relative max-w-sm h-72 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700 group">
        <div
          className="absolute inset-0 bg-cover bg-center rounded-lg bg-cover"
          style={{
            backgroundImage: `url(${content.thumbnail_url || 'https://via.placeholder.com/150'})`
          }}
        ></div>



        {/* Hover Effect - Username and Info on Hover */}
        <div className="absolute bottom-0 left-0 right-0 p-4 bg-black bg-opacity-50 text-white text-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p>Reel View - {content.reel_play_count.toLocaleString() || 'N/A'}</p> {/* Display reel play count */}
        </div>
      </div>
    ))}
  </div>
)}




<p className="text-3xl ml-6 mt-5">Top hashtags used in post</p>

{(!allHashtags || allHashtags.length === 0) ? (
  <p className="text-center text-xl text-gray-500 mt-5">No hashtags available</p>
) : (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 ml-6 mt-10">
    {allHashtags.map((tag, index) => (
      <div
        key={index}
        className="px-4 py-3 bg-gray-100 text-gray-800 text-lg font-medium rounded-md shadow-sm hover:bg-gray-200 transition"
      >
        {tag}
      </div>
    ))}
  </div>
)}









  </div>
)}















{/* Tab Content */}
{value === 1 && (
  <div style={{ padding: '16px' }}>
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg lg:ml-4 mt-4">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400 lg:ml-12">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Influencer Profile</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Deliverables</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Likes</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Comments</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">Reel Views</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">CPE</th>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">CPV</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            // Skeleton loading for table rows
            Array(5).fill().map((_, index) => (
              <tr key={index} className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700 border-gray-200">
                <td className="px-6 py-4">
                  <Skeleton circle height={40} width={40} />
                </td>
                <td className="px-6 py-4"><Skeleton width={120} /></td>
                <td className="px-6 py-4"><Skeleton width={60} /></td>
                <td className="px-6 py-4"><Skeleton width={60} /></td>
                <td className="px-6 py-4"><Skeleton width={60} /></td>
                <td className="px-6 py-4"><Skeleton width={60} /></td>
                <td className="px-6 py-4"><Skeleton width={60} /></td>
              </tr>
            ))
          ) : (
            Table.length === 0 ? (
              <tr>
                <td colSpan="7" className="px-6 py-4 text-center text-gray-500">
                  No table data available
                </td>
              </tr>
            ) : (
              Table.map((influencer, index) => (
                <tr key={index} className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700 border-gray-200">
                  <td className="px-6 py-4">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={influencer.profile_pic_url}
                        alt={influencer.influencer_name}
                        style={{ width: '40px', height: '40px', borderRadius: '50%', marginRight: '10px' }}
                      />
                      <p style={{ margin: 0 }}>{influencer.influencer_name}</p>
                    </div>
                  </td>
                  <td className="px-6 py-4">1/1 reel</td>
                  <td className="px-6 py-4">{influencer.likes}</td>
                  <td className="px-6 py-4">{influencer.comments}</td>
                  <td className="px-6 py-4">{influencer.reel_views}</td>
                  <td className="px-6 py-4">{influencer.cpe}</td>
                  <td className="px-6 py-4">{influencer.cpv}</td>
                </tr>
              ))
            )
          )}
        </tbody>
      </table>
    </div>
  </div>
)}
{value === 2 && (
  <div className="p-4 lg:ml-12">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:ml-12">
      {loading ? (
        Array(10).fill().map((_, index) => (
          <div key={index} className="group relative bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition duration-300">
            <Skeleton height={240} width="100%" />
          </div>
        ))
      ) : Content.length === 0 ? (
        <div className="text-center col-span-full py-8">
          <p className="text-xl text-gray-500">No content available</p>
        </div>
      ) : (
        Content.map((influencer, index) => (
          <div key={index} className="group relative bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition duration-300">
            <img
              src={influencer.reel_thumbnail} // Assuming 'reel_thumbnail' is a valid image URL or base64 string
              alt={`Reel Thumbnail ${index + 1}`}
              className="w-full h-60 object-fit-cover"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              {/* Caption Text with Smaller Font Size */}
              <p className="text-white text-sm font-semibold">{influencer.caption_text}</p>
            </div>

            {/* User Profile and Name on Hover */}
            <div className="absolute bottom-4 left-4 flex items-center space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <img
                src={influencer.profile_picture} // Assuming 'profile_picture' is a valid URL
                alt="User Profile"
                className="w-8 h-8 rounded-full object-cover"
              />
              <p className="text-white font-semibold">{influencer.user_name}</p>
            </div>

            {/* Like, Comment, View Iconsssss*/}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontSize: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ThumbUp style={{ fontSize: '14px' }} />
                <span style={{ marginLeft: '4px' }}>{formatNumber(influencer.like_count)}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Comment style={{ fontSize: '14px' }} />
                <span style={{ marginLeft: '4px' }}>{formatNumber(influencer.comment_count)}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Visibility style={{ fontSize: '14px' }} />
                <span style={{ marginLeft: '4px' }}>{formatNumber(influencer.play_count)}</span>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  </div>
)}


        </div>
      </div>
      <ToastContainer />

    </div>
  );
};

export default ViewReport;
